<i *ngIf="infoText" class="fa fa-info-circle" [ngbTooltip]="infoText | translate"></i>